// extracted by mini-css-extract-plugin
export default {"sortInfo":"sortInfo__ZDdjZ","sortInfoTooltip":"sortInfoTooltip__NDg1Y"};